import React, { Component } from 'react';

import PropTypes from 'prop-types';
import Menu from 'components/Menu/Menu';
import MenuItem from 'components/Menu/MenuItem';

import { CONTACT_ERRORS } from 'constants/contact';
import DeleteModal from './DeleteModal';
import BlacklistModal from './BlacklistModal';


class ActionsPopover extends Component {
  state = {
    deleteModalOpen: false,
    blacklistModalOpen: false,
  }

  toggleDeleteActionModal = () => {
    const { deleteModalOpen } = this.state;
    this.setState({
      deleteModalOpen: !deleteModalOpen,
    });
    this.props.handleClose();
  }

  toggleBlacklistActionModal = () => {
    const { blacklistModalOpen } = this.state;
    this.setState({
      blacklistModalOpen: !blacklistModalOpen,
    });
    this.props.handleClose();
  }

  render() {
    const {
      contact,
      getContacts,
      showNotification,
      anchorEl,
      handleClose,
    } = this.props;
    const { deleteModalOpen, blacklistModalOpen } = this.state;
    return (
      <React.Fragment>
        <DeleteModal
          isOpen={deleteModalOpen}
          getContacts={getContacts}
          contact={contact}
          toggle={this.toggleDeleteActionModal}
          showNotification={showNotification}
        />
        <BlacklistModal
          isOpen={blacklistModalOpen}
          getContacts={getContacts}
          contact={contact}
          toggle={this.toggleBlacklistActionModal}
          showNotification={showNotification}
        />
        <Menu
          id="popover-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {!contact.errors.some(err => err.error_type === CONTACT_ERRORS.BLACKLISTED) && (
            <MenuItem
              onClick={this.toggleBlacklistActionModal}
            >
              Do not contact
            </MenuItem>
            )}
          <MenuItem
            onClick={this.toggleDeleteActionModal}
          >
              Delete
          </MenuItem>
        </Menu>
      </React.Fragment>
    );
  }
}


ActionsPopover.propTypes = {
  getContacts: PropTypes.func.isRequired,
  showNotification: PropTypes.func.isRequired,
  contact: PropTypes.shape({
    id: PropTypes.string,
    contact_id: PropTypes.string,
    errors: PropTypes.arrayOf(PropTypes.shape({
      additional_data: PropTypes.string,
      error_type: PropTypes.string,
    })).isRequired,
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
  }).isRequired,
  anchorEl: PropTypes.element,
  handleClose: PropTypes.func.isRequired,
};

ActionsPopover.defaultProps = {
  anchorEl: null,
};


export default ActionsPopover;
